import creditCards from './credit-cards'
import promoCodes from './promo-codes'
import ratings from './ratings'
import referrals from './referrals'
import users from './users'
import userInfo from './user-info'
import transactions from './transactions'
import reservations from './reservations'
import countrySelect from './country-select'
import logs from './logs'

let sharedMutations = []
sharedMutations = sharedMutations.concat(creditCards.sharedMutations)
sharedMutations = sharedMutations.concat(promoCodes.sharedMutations)
sharedMutations = sharedMutations.concat(ratings.sharedMutations)
sharedMutations = sharedMutations.concat(referrals.sharedMutations)
sharedMutations = sharedMutations.concat(users.sharedMutations)
sharedMutations = sharedMutations.concat(userInfo.sharedMutations)
sharedMutations = sharedMutations.concat(transactions.sharedMutations)
sharedMutations = sharedMutations.concat(reservations.sharedMutations)
sharedMutations = sharedMutations.concat(countrySelect.sharedMutations)
sharedMutations = sharedMutations.concat(logs.sharedMutations)

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    creditCards.state,
    promoCodes.state,
    ratings.state,
    referrals.state,
    users.state,
    userInfo.state,
    transactions.state,
    reservations.state,
    countrySelect.state,
    logs.state
  ),
  mutations: Object.assign(
    creditCards.mutations,
    promoCodes.mutations,
    ratings.mutations,
    referrals.mutations,
    users.mutations,
    userInfo.mutations,
    transactions.mutations,
    reservations.mutations,
    countrySelect.mutations,
    logs.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/consumer/index.js